<div class="verifying-email-wrapper">
  <div class="alert-warning">
    <app-icon class="alert-icon">warning</app-icon>
    <span class="alert-title">{{ 'verifying_email.text_1' | translate }}</span>
  </div>
  <span>{{ 'verifying_email.text_2' | translate }} {{ email }}.</span>
  <span>{{ 'verifying_email.text_3' | translate }}<br>{{ 'verifying_email.text_4' | translate }}</span>
  <span>
    <button [ngClass]="{'sending-verify-email': sendingVerifyEmail}"
            class="send-verify-email"
            [disabled]="sendingVerifyEmail"
            (click)="resendVerifyEmail()">
      {{ 'verifying_email.text_5' | translate }}</button> {{ 'verifying_email.text_6' | translate }}
  </span>
</div>
